import script from "./noticeTab.vue?vue&type=script&setup=true&name=noticeTab&lang=js"
export * from "./noticeTab.vue?vue&type=script&setup=true&name=noticeTab&lang=js"

const __exports__ = script;

export default __exports__